module.exports = __webpack_public_path__ + "img/resume.ad0aca27.png";